import { toast } from "react-toastify";

/**
 * Copia um texto para a área de transferência sem travar a tela.
 *
 * O fallback anterior era `window.prompt`: modal nativo do navegador, que
 * bloqueia o renderizador enquanto está aberto. E ele não era exceção rara —
 * `navigator.clipboard.writeText` recusa com "Document is not focused" sempre
 * que a aba não está em foco (o caso de quem clica e olha para outra janela,
 * e o caso do navegador de QA). O resultado era a página parar de responder.
 *
 * Falhando, o texto sai num toast que não fecha sozinho: dá para selecionar e
 * copiar à mão, e nada bloqueia a tela.
 */
export const copiarTexto = async (texto, sucesso = "Link copiado.") => {
	if (!texto) return false;

	try {
		await navigator.clipboard.writeText(texto);
		toast.success(sucesso);
		return true;
	} catch {
		toast.error(`Não consegui copiar. Selecione e copie à mão: ${texto}`, {
			autoClose: false,
			closeOnClick: false,
		});
		return false;
	}
};

export default copiarTexto;
